<template>
    <v-row class="pb-offset ma-0"> 

        <v-col class="pa-0 pt-1 col-12">
            <dashboard-kpi></dashboard-kpi>
        </v-col>

        <v-col class="pl-0 pt-5 pb-1" :class="calcWidth('opportunity', 1)" v-if="$store.getters.checkModelPermissions('opportunity')">
            <opportunities-status>
            </opportunities-status>
        </v-col>
        <v-col class=" pt-5 pb-1" :class="calcWidth('quotation', 2)" v-if="$store.getters.checkModelPermissions('quotation')">
            <quotations-status>
            </quotations-status>
        </v-col>
        
        <v-col class=" pt-5 pb-1 pr-0" :class="calcWidth('calendar', 3)" v-if="$store.getters.checkModelPermissions('calendar')">
            <my-events>
            </my-events>
        </v-col>

        <v-col cols="12" class="pa-0 pt-3 pb-0" v-if="$store.getters.checkModelPermissions('task')">
            <crud 
                title='Task assegnati a me'
                action-icon='dns'
                model-def='tasks'
                action-position='absolute'
                :default-input="{priority: 'c'}"
                :sub-filters="{users:true, taskarchived:false}"
            ></crud>
        </v-col>
        <v-col cols="12" class="pa-0 pt-4 pb-0" v-if="$store.getters.checkModulePermissions('tickets')">
            <crud 
                title='Ticket assegnati a me'
                action-icon='receipt'
                model-def='troubles'
                action-position='absolute'
                :default-input="{priority: 'c'}"
                :sub-filters="{user:true, not_closed: true}"
            ></crud>
        </v-col>

        <v-col cols="12" class="pa-0 pt-4 pb-0" v-if="$store.getters.checkModelPermissions('visit')">
            <crud 
                title='Visite di Manutenzione'
                action-icon='receipt'
                model-def='visits'
                action-position='absolute'
                :sub-filters="{owner_id: true, trouble_id:'null'}"
            ></crud>
        </v-col>
        <v-col cols="12" class="pa-0 pt-4">
            <mail-logs
                :quick-send="false"
                :card-class="['elevation-0']"
            ></mail-logs>
        </v-col>
        <v-col cols="12" class="pa-0 pt-4" v-if="$store.getters.checkModulePermissions('marbec')">
            <crud
                title='Azioni automatiche'
                model-def='schedules'
                action-position='absolute'
                action-icon='repeat'            
            ></crud>
        </v-col>
    </v-row>
</template>

<script>

    import DashboardKpi from '@/components/modules/dashboard/DashboardKpi'
    import MailLogs from '@/components/common/MailLogs'
    import QuotationsStatus from '@/components/modules/dashboard/QuotationsStatus'
    import OpportunitiesStatus from '@/components/modules/dashboard/OpportunitiesStatus'
    import OrdersStatus from '@/components/modules/dashboard/OrdersStatus'
    import MyEvents from '@/components/modules/dashboard/MyEvents'

    export default {
        name: "dashboard",
        components: {
            MyEvents,
            MailLogs,
            DashboardKpi,
            OrdersStatus,
            QuotationsStatus,
            OpportunitiesStatus
        },

        props: {

        },

        data() {
            return {}
        },
        
        computed: {
            calcWidth(model, oder) {
                return (model, order) => {
                    let calendar = this.$store.getters.checkModelPermissions('calendar')
                    let quotation = this.$store.getters.checkModelPermissions('quotation')
                    let opportunity = this.$store.getters.checkModelPermissions('opportunity')

                    let string_class = ''
                    if(this.$vuetify.breakpoint.smAndDown && order != 1) {
                        string_class = ' pt-4'
                    }
    
                    if(opportunity && quotation && calendar) {
                        return 'col-12 col-sm-12 col-md-4' + string_class
                    }

                    if(opportunity && quotation && !calendar) {
                        if(model == 'opportunity') {
                            return 'col-12 col-sm-12 col-md-6 pr-2' + string_class
                        } else if(model == 'quotation'){
                            return 'col-12 col-sm-12 col-md-6 pl-2' + string_class
                        }
                        
                        return 'col-12 col-sm-12 col-md-6'
                    }
    
                }
            }
        },

        mounted() {
            this.$store.commit('endProgress')
        }
    }
</script>